import { render, staticRenderFns } from "./report-students-asisstance-component.vue?vue&type=template&id=586c2738&scoped=true&"
import script from "./report-students-asisstance-component.vue?vue&type=script&lang=js&"
export * from "./report-students-asisstance-component.vue?vue&type=script&lang=js&"
import style0 from "./report-students-asisstance-component.vue?vue&type=style&index=0&id=586c2738&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586c2738",
  null
  
)

export default component.exports